export const extendedProps = [
    'email',
    'phone',
    'address',
    'furnitureCount',
    'weight',
    'invoiceAmount',
    'deliveryFee',
    'status',
    'isShipped'
]

export const recordExtendedProps = [
    'deliverId',
    'deliverName',
    'mapUrl',
    'orderId',
    'status',
    'drivingKm',
    'longDrivingKm',
    'drivingTime',
    'weight',
    'carbonReduction',
]

export const staffOrderExtendedProps = [
    'id',
    'company',
    'name',
    'phone',
    'plate',
    'isReturned',
    'category',
    'furnitureCount',
    'status',
    'usedAt',
    'finishAt',
    'returnAt',
]